import type { ButtonVariant } from '@skupreme/shared/ui';
import type {
  MappingSuggestionRow,
  SuggestionCandidate,
  SuggestionView,
} from '../../lib/suggestion-types';
import { GatedButton } from './GatedButton';

export type RowAction =
  | 'confirm'
  | 'pick'
  | 'skip'
  | 'restore'
  | 'create'
  | 'exclude';

export type RowHandlers = Record<
  RowAction,
  (row: MappingSuggestionRow) => void
> & {
  /** One-click choice among the candidates of a listing with no suggestion. */
  choose: (row: MappingSuggestionRow, candidate: SuggestionCandidate) => void;
};

const ACTIONS: Record<
  SuggestionView,
  { action: RowAction; label: string; variant: ButtonVariant }[]
> = {
  to_review: [
    { action: 'confirm', label: 'Confirm', variant: 'primary' },
    { action: 'pick', label: 'Change', variant: 'pill' },
    { action: 'skip', label: 'Skip', variant: 'ghost' },
  ],
  no_match: [
    { action: 'pick', label: 'Map', variant: 'primary' },
    { action: 'create', label: 'Create item', variant: 'ghost' },
    { action: 'exclude', label: 'Exclude', variant: 'ghost' },
  ],
  skipped: [
    { action: 'restore', label: 'Restore', variant: 'primary' },
    { action: 'pick', label: 'Map', variant: 'ghost' },
  ],
};

export type SuggestionActionsProps = {
  view: SuggestionView;
  row: MappingSuggestionRow;
  handlers: RowHandlers;
  isReadOnly?: boolean;
  isBusy?: boolean;
};

/** The buttons of one row; which ones depends on the queue. */
export function SuggestionActions({
  view,
  row,
  handlers,
  isReadOnly,
  isBusy,
}: SuggestionActionsProps) {
  return (
    <div className="sk:flex sk:flex-wrap sk:items-center sk:justify-end sk:gap-2">
      {ACTIONS[view].map(({ action, label, variant }) => (
        <GatedButton
          key={action}
          variant={variant}
          size="sm"
          isReadOnly={isReadOnly}
          isDisabled={isBusy}
          onPress={() => handlers[action](row)}
        >
          {label}
        </GatedButton>
      ))}
    </div>
  );
}
